import React, { Suspense } from 'react';
import HookedRouter from '../../features/hooked-router';

export default function AppComponent(props) {
    const { authenticated } = props;

    if (!authenticated) {
        const LoginLayout = React.lazy(() => import('../../layouts/Login/LoginLayout'));
        return (
            <Suspense fallback={null}>
                <LoginLayout />
            </Suspense>
        );
    } else {
        const AdminLayout = React.lazy(() => import('../../layouts/Admin/AdminLayout'));
        return (
            <Suspense fallback={null}>
                <HookedRouter>
                    <AdminLayout onLogoutRequested={props.onLogoutRequested} />
                </HookedRouter>
            </Suspense>
        );
    }
}
